export function KakaoAuthInitialize() {
  const { Kakao } = window;

  const KAKAO_KEY = import.meta.env.VITE_APP_KAKAO_JAVASCRIPT_KEY;
  if (!Kakao.isInitialized()) Kakao.init(KAKAO_KEY);
}
